<template>
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
  >
    <defs>
      <clipPath id="a"><path fill="none" d="M0 0h30v30H0z" /></clipPath>
    </defs>
    <g fill="none" clip-path="url(#a)">
      <path d="M0 0h30v30H0z" />
      <path
        d="m15.293 7.416 1.365-1.365a5.156 5.156 0 0 1 7.292 7.29l-3.315 3.317a5.156 5.156 0 0 1-7.292 0"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="2"
      />
      <path
        d="m14.708 22.585-1.367 1.365a5.156 5.156 0 0 1-7.29-7.292l3.315-3.314a5.156 5.156 0 0 1 7.292 0"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="2"
      />
    </g>
  </svg>
</template>
